import { ReturnPolicySnapshotStatus } from "@redotech/crdb-enums/returns/return-policy-snapshot-status";
import { ReturnPolicySnapshotSettingsSchema } from "@redotech/redo-return-core-common/return-policy/snapshot-settings";
import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** One page of a policy's versions, newest first, with the settings just below the page for its last change list. */
export const getReturnPolicyVersions = {
  name: "getReturnPolicyVersions" as const,
  input: z.object({
    id: returnPolicyIdFormat.schema,
    before: z.number().int().nullable(),
  }),
  output: z.object({
    versions: z.array(
      z.object({
        versionNumber: z.number().int(),
        status: z.enum(ReturnPolicySnapshotStatus),
        name: z.string().nullable(),
        publishedAt: z.date().nullable(),
        updatedAt: z.date(),
        authorName: z.string().nullable(),
        settings: ReturnPolicySnapshotSettingsSchema,
      }),
    ),
    previous: ReturnPolicySnapshotSettingsSchema.nullable(),
    nextCursor: z.number().int().nullable(),
  }),
};
